import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class ScrollPositionService extends BehaviorSubject<any> {
    constructor() {
        const currentScrollPosition = { x: window.scrollX, y: window.scrollY };
        super(currentScrollPosition);
    }
}
